<template>
  <div class="mx-2">
    <b-alert variant="info" show class="mb-3">
      <i class="fa fa-info-circle"></i>
      Puedes realizar una o más acciones simultáneamente. Completa los campos que desees y presiona "Enviar".
    </b-alert>   
    
    <b-row>
      <b-col md="6" class="mb-3">
        <label for="estado">Estado</label>
        <el-select
          v-model="estado"
          filterable
          clearable
          placeholder="Seleccionar estado"
          no-data-text="No hay datos que coincidan"
          no-match-text="No hay datos que coincidan"
        >
          <el-option
            v-for="estado in estados"
            :key="estado.value"
            :label="estado.text"
            :value="estado.value"
          >
          </el-option>
        </el-select>
      </b-col>      
      <b-col md="6" class="mb-3">
        <label for="profesional">Profesional</label>
        <el-select
          v-model="profesional"
          filterable
          clearable
          placeholder="Seleccionar profesional"
          no-data-text="No hay datos que coincidan"
          no-match-text="No hay datos que coincidan"
        >
          <el-option
            v-for="usuario in usuarios"
            :key="usuario.value"
            :label="usuario.text"
            :value="usuario.value"
          >
          </el-option>
        </el-select>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="4" class="mb-3 mt-3">
        <label for="redactarMensaje"> Redactar Mensaje </label>
        <b-form-radio-group
          class="ml-3"
          id="redactarMensaje"
          name="redactarMensaje"
          @change="redactarParametrizarMensaje"
          v-model="redactarMensaje"
          :options="opciones"
          buttons
          :button-variant="redactarMensaje ? 'outline-primary' : 'outline-secondary'"
        />
      </b-col>
    </b-row>
    
    <b-row>
      <b-col v-if="redactarMensaje" md="12" class="mb-3">
        <b-form-textarea
          id="textarea"
          name="observación"
          v-model="observacion"
          placeholder="Observacion..."
          rows="4"
          max-rows="6"
          :state="validarObservacion"
        ></b-form-textarea>
        <b-form-invalid-feedback v-if="observacion && !validarObservacion">
          El mensaje no puede contener solo espacios en blanco
        </b-form-invalid-feedback>
      </b-col>
      <b-col v-else-if="!redactarMensaje">
        <b-table
          class="mt-3"
          bordered
          responsive
          striped
          hover
          small
          :items="mensajesMasivos.data"
          :fields="columnas"
          empty-text="No hay información para mostrar"
          thead-tr-class="table-active"
        >
          <template v-slot:cell(marcar)="data">
            <el-checkbox
              :value="obtenerValor(data.item)"
              @change="obtenerMensaje(data.item, $event)"
            ></el-checkbox>
          </template>
        </b-table>
        <el-pagination
          v-model="filtrosListas.page"
          class="float-right w-100 d-flex justify-content-end"
          :page-sizes="[10, 30, 50, 100]"
          :current-page="filtrosListas.page"
          :page-size="filtrosListas.perPage"
          @size-change="setPerPagePaginationMasivo"
          @current-change="setPagePaginationMasivo"
          layout="total, prev, pager, next"
          :total="mensajesMasivos.total"
          small
        />
      </b-col>
    </b-row>
    
    <b-row>
      <b-col md="12" class="text-right">
        <b-button
          small
          variant="primary"
          @click="guardarEnviar"
          class="mt-3"
          :disabled="validateForm"
        >
          <i class="fa fa-paper-plane fa-lg"> </i>
          Enviar
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { mapActions, mapMutations, mapState } from "vuex";

export default {
  name: "acciones-masivo",
  data() {
    return {
      profesional: null,
      observacion: null,
      estado: null,
      redactarMensaje: 1,
      columnas: [
        {
          key: "marcar",
          label: "",
          thClass: "text-center",
          tdClass: "text-center",
          thStyle: { "max-width": "50px", width: "50px !important" },
        },
        {
          key: "lista",
          label: "Observación",
          sortable: true,
        },
      ],
      opciones: [
        { value: 1, text: "Si" },
        { value: 0, text: "No" },
      ],
    };
  },
  props: {
    modal: {
      default: 1
    }
  },
  async created() {
    if (!this.mensajesMasivos.data) {
      await this.listarListasPorCodigo(this.filtrosListas);
    }
  },
  methods: {
    redactarParametrizarMensaje() {
      this.observacion = null;
    },
    obtenerValor(observacion) {
      return this.observacion == observacion.lista;
    },
    async obtenerMensaje(observacion, state) {
      if (!state) {
        this.observacion = null;
      } else {
        this.observacion = observacion.lista;
      }
    },
    async guardarEnviar() {
      const data = {
        idTickets: this.ticketsSeleccionados
      };

      if (this.observacion && this.observacion.trim().length > 0) {
        data.observacion = this.observacion.trim();
      }

      if (this.profesional) {
        data.id_responsable = this.profesional;
      }

      if (this.estado) {
        data.id_estado = this.estado;
      }

      await this.ejecutarAccionesMasivas(data);
      await this.listarTickets();
      this.observacion = null;
      this.profesional = null;
      this.estado = null;
      this.setDefaultTicketsSeleccionados();
      this.$emit("cerrarModal");
    },
    ...mapActions("tickets", [
      "listarListasPorCodigo",
      "guardarObservacionMasivo",
      "guardarProfesionalMasivo",
      "actualizarEstadoMasivo",
      "ejecutarAccionesMasivas",
      "listarTickets",
      "setPerPagePaginationMasivo",
      "setPagePaginationMasivo"
    ]),
    ...mapMutations("tickets", [
      "setDefaultTicketsSeleccionados"
    ]),
  },
  computed: {
    validarObservacion() {
      if (!this.observacion) return null; 
      return this.observacion.trim().length > 0;
    },
    validateForm() {
      const tieneObservacion = this.observacion && this.observacion.trim().length > 0;
      const tieneProfesional = this.profesional;
      const tieneEstado = this.estado;
      
      return !tieneObservacion && !tieneProfesional && !tieneEstado;
    },
    ...mapState("tickets", [
      "mensajesMasivos",
      "filtrosListas",
      "ticketsSeleccionados",
      "usuarios",
      "filtroEt",
      "estados"
    ]),
  },
};
</script>
